function submitForm() {
  var forms = document.querySelectorAll('.form');

  forms.forEach(function (form) {
    form.reset();
  });

  function showThanks() {
    var popupThanks = document.getElementById('popup-thanks');
    var overlay = document.querySelector('.overlay');

    var closeButtons = document.querySelectorAll('.carousel__button.is-close');

    closeButtons.forEach(function(button) {
        button.click();
    });
    popupThanks.style.display = 'flex';
    popupThanks.style.opacity = '1';
    popupThanks.style.visibility = 'visible';
    overlay.style.opacity = '1';
    overlay.style.visibility = 'visible';
  }

  function hideThanks() {
    var popupThanks = document.getElementById('popup-thanks');
    var overlay = document.querySelector('.overlay');

    popupThanks.style.display = 'none';
    popupThanks.style.opacity = '0';
    popupThanks.style.visibility = 'hidden';
    overlay.style.opacity = '0';
    overlay.style.visibility = 'hidden';
  }

  showThanks();

  setTimeout(function () {
    hideThanks();
  }, 2000);
}

document.querySelectorAll('.form').forEach(function (form) {
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    submitForm();
  });
});

